<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('master.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('master.name')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- .type -->
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('master.editor_font_type')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="type"
                  vid="type"
                  rules="required"
                >
                  <select class="form-control" v-model="newItem.type">
                    <option value="">{{ $t("site.choose") }}</option>
                    <option value="Amiri">Amiri</option>
                    <option value="Droid Arabic Kufi">Droid Arabic Kufi</option>
                    <option value="Droid Arabic Naskh">
                      Droid Arabic Naskh
                    </option>
                    <option value="Lateef">Lateef</option>
                    <option value="Scheherazade">Scheherazade</option>
                    <option value="Thabit">Thabit</option>
                  </select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .size -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('master.size')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="size"
                  vid="size"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.size"
                    type="number"
                    :placeholder="$t('master.size')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .color -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('master.color')"
                label-for="input-4"
              >
                <color-panel v-model="newItem.color"></color-panel>
              </b-form-group>
            </b-col>
            <!-- .bold -->
            <b-col lg="6">
              <div class="demo-inline-spacing">
                <!-- primary -->
                <div>
                  <b-card-text class="mb-0"> Bold </b-card-text>
                  <b-form-checkbox
                    v-model="newItem.bold"
                    class="custom-control-primary"
                    name="check-button"
                    switch
                    value="1"
                  >
                    <span class="switch-icon-left"> B </span>
                    <span class="switch-icon-right"> Not </span>
                  </b-form-checkbox>
                </div>
                <div>
                  <b-card-text class="mb-0"> Italic </b-card-text>
                  <b-form-checkbox
                    v-model="newItem.italic"
                    class="custom-control-primary"
                    name="check-button"
                    value="1"
                    switch
                  >
                    <span class="switch-icon-left"> I </span>
                    <span class="switch-icon-right"> Not </span>
                  </b-form-checkbox>
                </div>
              </div>
            </b-col>
            <!-- .italic -->
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('master.italic')"
                label-for="input-6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="italic"
                  vid="italic"
                  rules="required"
                >
                  <b-form-input
                    id="input-6"
                    v-model="newItem.italic"
                    type="text"
                    :placeholder="$t('master.italic')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MasterEditorFormatController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { ColorPicker, ColorPanel } from "one-colorpicker";

export default {
  name: "MasterEditorFormatForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    ColorPicker,
    ColorPanel,
  },
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>

